import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { POST } from '../api';
import { SixdeeCRBTAPI } from '../sixdeecrbtapi';
import { RewardPointRequest } from './rewardpointrequest';

export class RewardPointAPI extends SixdeeCRBTAPI<RewardPointRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpHeaders():string
    {
       let baseHeaders = super.getHttpHeaders();
       let combinedHeaders : any;

       let tokenHeader = {
            "Authorization" : "Bearer "+this.getRequest().getToken()
       } as any; 

       combinedHeaders = Object.assign(tokenHeader, baseHeaders);
       return combinedHeaders;
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        return "selfcare-olp/get-reward-points";
    }

    getRequestData()
    {
        // return "msisdn=" + this.getRequest().getMsisdn();
        return {
            msisdn: this.getRequest().getMsisdn()
        };
    }

    
    getBASEURL(): string
    {
        return this.getContext().getProperty().getRewardPointURL() + 
            this.getAPIURL();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/rewardpoint/rewardpointapi.tsx